/* eslint-disable no-shadow-restricted-names */
/* eslint-disable array-callback-return */
import {  useState,useEffect ,useContext} from "react";
import { useMutation} from "@apollo/client";
import { AdminContext } from "../../../context/AdminContext/AdminContext";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import {DELETE_EXT_PER_EVAL,GET_PEFORMANCE_EVALUATION_COLLBORATORS } from "../../../Querys/performanceEvaluation/querys";
import {openColExtPerfEvalModal } from "../../../context/PerformanceEvaluationContext/Actions";
import Box from '@mui/material/Box';
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { WarningAlert } from '../../../alerts/WarningAlert';
import { ErrorAlert } from "../../../alerts/errorAlert";
import { SuccessfulAlert } from "../../../alerts/successAlerts";

type MenuSelectProps={
    id:number,
    arraySelect?:any,
    typeEval:string,
    typeArray:string,
    arrayEval?:any
    setArrayEval?:any
    typeArrayEval?:any
}
const filterUser=(array:any,id:any)=>{
    const newSelect= array?.filter((el:any) => {
        return el.id === id ;
      });      
      return newSelect
}


const validaSelect=(array:any, typeArrayEval:any,msg:any)=>{
 let error:boolean=false  
  switch (typeArrayEval) {
    case 'lider':
      if(array.length ===0){
        error=true 
        return ErrorAlert({ text: 'Seleccione a un líder.' });
      } 
     if (!array[0].hasOwnProperty('lider')) {
         error=true 
         return ErrorAlert({ text: 'Seleccione a un líder.' });         
      }   
      array.map((user:any)=>{
         if(user.lider[0].typeEvaluator === 'lider'){                     
            error=true 
            return  ErrorAlert({ text: `No es posible ${msg} a un líder que no sea externo` });             
          }
       })               
    return error
    case 'colega':
        if(array.length ===0){
          error=true 
          return ErrorAlert({ text: 'Seleccione a un colega.' });
        } 
       if (!array[0].hasOwnProperty('colega')) {
           error=true 
           return ErrorAlert({ text: 'Seleccione a un colega.' });         
        }   
        array.map((user:any)=>{
           if(user.colega[0].typeEvaluator === 'colega'){                     
              error=true 
              return  ErrorAlert({ text: `No es posible ${msg} a un colega que no sea externo` });             
            }
         })               
      return error
      case 'subornidado':
        if(array.length ===0){
          error=true 
          return ErrorAlert({ text: 'Seleccione a un subornidado.' });
        } 
       if (!array[0].hasOwnProperty('subornidado')) {
           error=true 
           return ErrorAlert({ text: 'Seleccione a un subornidado.' });         
        }   
        array.map((user:any)=>{
           if(user.subornidado[0].typeEvaluator === 'subornidado'){                     
              error=true 
              return  ErrorAlert({ text: `No es posible ${msg} a un subornidado que no sea externo` });             
            }
         })               
      return error  
      case 'cliente':
        if(array.length ===0){
          error=true 
          return ErrorAlert({ text: 'Seleccione a un cliente.' });
        } 
       if (!array[0].hasOwnProperty('cliente')) {
           error=true 
           return ErrorAlert({ text: 'Seleccione a un cliente.' });         
        }   
        array.map((user:any)=>{
           if(user.cliente[0].typeEvaluator === 'cliente'){                     
              error=true 
              return  ErrorAlert({ text: `No es posible ${msg} a un cliente que no sea externo` });             
            }
         })               
      return error       
   }
 }

const validateTypeForView=(array:any,typeArrayEval:any)=>{
  let newSelect:any
  switch (typeArrayEval) {
    case 'lider':   
    newSelect=array?.filter((el:any) => {            
        return el.typeEvaluator === 'lider-ext' ;
      });           
    return newSelect  
    case 'colega': 
    newSelect=array?.filter((el:any) => {              
      return el.typeEvaluator !== 'colega' ;
    });                       
    return newSelect   
    case 'subornidado':
      newSelect=array?.filter((el:any) => {             
        return el.typeEvaluator !== 'subornidado' ;
      });                       
    return newSelect   
    case 'cliente':
      newSelect=array?.filter((el:any) => {         
        return el.typeEvaluator !== 'cliente' ;
      });                       
      return newSelect   

  }
}

const MenuSelect = ({id,arraySelect,typeEval,typeArray,arrayEval, typeArrayEval}:MenuSelectProps) => {
    const { adminState } = useContext(AdminContext)    
    const {state, dispatch} = useContext(PerformanceEvaluationContext);     
    const [anchorEl, setAnchorEl] = useState<any>(null);
    const [viewOptions,setViewOptions]= useState(false)
    const [disabledMenu]= useState(false)
    
    const open = Boolean(anchorEl);   
    const openMenu = (e: any): void => {
      setAnchorEl(e.currentTarget);
    };
    
    const idEvalDesCol= state._id || 0

    const [deleteEvalExt] = useMutation(DELETE_EXT_PER_EVAL, {
        refetchQueries: [
          {
            query: GET_PEFORMANCE_EVALUATION_COLLBORATORS ,
            variables: { idPerEval:idEvalDesCol, idCompany:adminState?.idEnterprise  },
          },
      ],
  });
  
   useEffect(()=>{    
    const copyArraySelect=[...arraySelect]
     if(copyArraySelect){
      let res:any 
        switch (typeEval) {
          case '90':      
          res=validateTypeForView(copyArraySelect,typeArrayEval)
          if(res.length >0)
            {
              setViewOptions(true)
            }else{
              setViewOptions(false)
            }
          break;
          case '180':      
          res=validateTypeForView(copyArraySelect,typeArrayEval)
          if(res.length >0)
            {
              setViewOptions(true)
            }else{
              setViewOptions(false)
            }
          break;
          case '270':      
          res=validateTypeForView(copyArraySelect,typeArrayEval)
          if(res.length >0)
            {
              setViewOptions(true)
            }else{
              setViewOptions(false)
            }
          break;
          case '360':      
          res=validateTypeForView(copyArraySelect,typeArrayEval)
          if(res.length >0)
            {
              setViewOptions(true)
            }else{
              setViewOptions(false)
            }
          break;
          }
      }
    },[arraySelect, typeArrayEval, typeEval])    


    const eliminaEval=async(infoEval:any,typearrayEval:any)=>{
     let response
      if(typearrayEval === 'lider'){  
        response = await WarningAlert({ text: `¿Deseas eliminar al líder?`, showDenyButton: true, confirmButtonText: "Eliminar" });
       }else if(typearrayEval === 'subornidado')
        response = await WarningAlert({ text: `¿Deseas eliminar al subordinado?`, showDenyButton: true, confirmButtonText: "Eliminar" });
       else {
        response = await WarningAlert({ text: `¿Deseas eliminar al ${typearrayEval}?`, showDenyButton: true, confirmButtonText: "Eliminar" });
       }
       if (response.isConfirmed) {               
            let copyValues:any
            switch (typearrayEval) {
                case 'lider':  
                 copyValues={id:infoEval.lider[0].id,idEval:infoEval.idEval,idUser:infoEval.id,type:'idLider' }  
                 arrayEval.map((col:any)=>{
                  if(col.id === id){
                    col.idLider=null
                    delete col.lider;
                  }
                 })                 
                break;
                case  'colega':  
                copyValues={id:infoEval.colega[0].id,idEval:infoEval.idEval,idUser:infoEval.id,type:'idColega' }   
                arrayEval.map((col:any)=>{
                  if(col.id === id){
                    col.idColega=null
                    delete col.colega;
                  }
                 })       
                break;
                case  'subornidado':  
                copyValues={id:infoEval.subornidado[0].id,idEval:infoEval.idEval,idUser:infoEval.id,type:'idSubornidado' }  
                arrayEval.map((col:any)=>{
                  if(col.id === id){
                    col.idSubornidado=null
                    delete col.subornidado;
                  }
                 })            
                break;
                case  'cliente':  
                copyValues={id:infoEval.cliente[0].id,idEval:infoEval.idEval,idUser:infoEval.id,type:'idCliente' }      
                arrayEval.map((col:any)=>{
                  if(col.idUser === id){
                    col.idClientea=null
                    delete col.cliente;
                  }
                 })      
                break;
              }                  
              await deleteEvalExt({
                    variables:{                   
                      input: copyValues,
                    }                 
                });
                if(typearrayEval === 'lider'){  
                SuccessfulAlert({ text: `El líder fue eliminado correctamente.`});
                }
                else if(typearrayEval === 'subornidado'){  
                  SuccessfulAlert({ text: `El subordinado fue eliminado correctamente.`});
                  }
                else{
                  SuccessfulAlert({ text: `El ${typearrayEval} fue eliminado correctamente.`});
                }
           }
    }
      
    const openModalExterno=(id:number,typeEval:string,typeArray:string)=>{       
        openColExtPerfEvalModal(idEvalDesCol.toString(),id,typeEval,typeArray,null,true, dispatch)
    }

    const openDeleteModalExterno=async (id:number,typeEval:string,arrayEval:any,typeArrayEval:any)=>{
        const resFilter= filterUser(arrayEval,id)         
         let res:any
         switch (typeEval) {
            case '90':
              res= validaSelect(resFilter,typeArrayEval,'eliminar')
              if(!res){
                eliminaEval(resFilter[0],typeArrayEval)
              }
             return  
             case '180':
                res=  validaSelect(resFilter,typeArrayEval,'eliminar')
                if(!res){
                    eliminaEval(resFilter[0],typeArrayEval)
                  }
              return  
              case '270':
                console.log(resFilter)
                res= validaSelect(resFilter,typeArrayEval,'eliminar')
                if(!res){
                    eliminaEval(resFilter[0],typeArrayEval)
                  }
              return    
              case '360':
                res=  validaSelect(resFilter,typeArrayEval,'eliminar')
                if(!res){
                    eliminaEval(resFilter[0],typeArrayEval)
                  }
              return             
        }      
    }

    const openUpdateModalExterno=(id:number,typeEval:string,typeArray:string,arrayEval:any)=>{
        const resFilter= filterUser(arrayEval,id)
        let res:any
        switch (typeEval) {
            case '90':
              res= validaSelect(resFilter,typeArrayEval,'editar')
              if(!res){
                openColExtPerfEvalModal(idEvalDesCol.toString(),id,typeEval,typeArray,resFilter,true, dispatch)
              }
             return  
             case '180':
                res=  validaSelect(resFilter,typeArrayEval,'editar')
                if(!res){
                    openColExtPerfEvalModal(idEvalDesCol.toString(),id,typeEval,typeArray,resFilter,true, dispatch)
                  }
              return  
              case '270':
                console.log(resFilter)
                res= validaSelect(resFilter,typeArrayEval,'editar')
                if(!res){
                    openColExtPerfEvalModal(idEvalDesCol.toString(),id,typeEval,typeArray,resFilter,true, dispatch)
                  }
              return    
              case '360':
                res=  validaSelect(resFilter,typeArrayEval,'editar')
                if(!res){
                    openColExtPerfEvalModal(idEvalDesCol.toString(),id,typeEval,typeArray,resFilter,true, dispatch)
                  }
              return             
        }            
    }

  return (
    <>
    <Box mr={2} 
       className="menuListNewPrestacion">
          <IconButton onClick={openMenu}
             className="menuListOptionNewPrestacion"
           >
            <MoreVertIcon  className="moreOptionNewPrestacion"  />  
            </IconButton>
          </Box>
   
      <Menu
          className="MoreVerIcon"
          anchorEl={anchorEl}          
          open={open}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() => setAnchorEl(null)}>

          <MenuItem 
               onClick={() => openModalExterno(id,typeEval,typeArray)}
               >
              <div   className="contenedorTextoMenuPrestacion" >
                  <span className="textoMenuEditarPrestacion" >Externo</span>
              </div>
              <div style={{ marginLeft: "24px" }}>
                 <PersonAddAlt1Icon className="iconoMenuViewPrestacion" />
              </div>
          </MenuItem>  

          {viewOptions && (
            <div>
           <MenuItem 
           onClick={() => openUpdateModalExterno(id,typeEval,typeArray,arrayEval)}
           disabled={disabledMenu}
           >
               <div  className="contenedorTextoMenuPrestacion" >
                   <span className="textoMenuEditarPres" >Editar</span>
               </div>
               <div  className="imgEditaPres" >
                   <img className="iconoMenuPres"   src="/assets/svg/icono-editar.svg" alt="Editar" />
               </div>
           </MenuItem>
         
           <MenuItem 
           onClick={() => openDeleteModalExterno(id,typeEval,arrayEval,typeArrayEval)}
           disabled={disabledMenu}
            >
           <div className="contenedorTextoMenuPrestacion" >
               <span className="textoMenuEliminarPrestacion">Eliminar</span>
           </div>
           <div className="imgDeletePres">
               <img 
                className="iconoMenuEliminarPrestacion"
                src="/assets/svg/icono-eliminar.svg" alt="Eliminar" />
           </div>
           </MenuItem>         
           </div>
           )
          }       
      </Menu>        
  </>
  )
}

export default MenuSelect